module.exports = __webpack_public_path__ + "static/logo-c6fbfe39539004e7cac8e379bdd4e455.png";